/**
 * PWA Development Configuration
 * Suppress non-critical workbox warnings in development
 */

// Configure Workbox logging
if (typeof window !== 'undefined') {
  // Disable Workbox logging globally
  if (import.meta.env.DEV) {
    // In development, we might see Workbox logs - suppress them
    const originalLog = console.log;
    const originalWarn = console.warn;
    const originalError = console.error;

    console.log = (...args: any[]) => {
      const message = String(args[0] || '');
      
      // Suppress workbox and service worker logs in dev
      if (
        message.includes('workbox') ||
        message.includes('[WB_') ||
        message.includes('No cached response') ||
        message.includes('Network request for') ||
        message.includes('Precaching')
      ) {
        return;
      }
      
      originalLog.apply(console, args);
    };

    console.warn = (...args: any[]) => {
      const message = String(args[0] || '');
      
      // Suppress non-critical warnings
      if (
        message.includes('Workbox') ||
        message.includes('workbox') ||
        message.includes('Vary: Origin') ||
        message.includes('WB_REVISION') ||
        message.includes('Precaching') ||
        message.includes('No route found') ||
        message.includes('cache')
      ) {
        return;
      }
      
      originalWarn.apply(console, args);
    };

    console.error = (...args: any[]) => {
      const message = String(args[0] || '');
      
      if (
        message.includes('workbox') ||
        message.includes('Precaching') ||
        message.includes('No route found')
      ) {
        return;
      }
      
      originalError.apply(console, args);
    };
  }
}

/**
 * Initialize PWA monitoring
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.ready;

      // Auto-check for updates every 5 minutes
      setInterval(async () => {
        await registration.update();
      }, 5 * 60 * 1000);

      // Listen for controller changes (SW update)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Silently update - no need to log in dev
      });
    } catch (error) {
      // Silently fail
    }
  });
}
